"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Color = void 0;
let Color = exports.Color = /*#__PURE__*/function (Color) {
  Color["RED"] = "red";
  Color["PINK"] = "pink";
  Color["ORANGE"] = "orange";
  Color["YELLOW"] = "yellow";
  Color["LIME"] = "lime";
  Color["GREEN"] = "green";
  Color["CYAN"] = "cyan";
  Color["BLUE"] = "blue";
  Color["INDIGO"] = "indigo";
  Color["PURPLE"] = "purple";
  return Color;
}({});